import { UPSELL_TYPE } from '@square/appointments-feature-upsell/constants';
export const UPSELL_EVENT_DELAY = 500;
export function upsellTrackingData({
  routerService,
  planToken,
  featureId,
  upsellType,
  hasUsedFreeTrial
}) {
  // If the upsellType is beta_feature, that's a beta pill.
  // If user is on the free trial they'll see a "subscribe"
  // CTA. If not, they'll see "subscribe" if they've already
  // used the free trial or "try free" if they haven't used
  // their free trial yet.
  let intent = upsellType;
  if (upsellType === UPSELL_TYPE.FREE_TRIAL) {
    intent = 'subscribe';
  } else if (upsellType === UPSELL_TYPE.PAYWALL) {
    if (hasUsedFreeTrial) {
      intent = 'subscribe';
    } else {
      intent = 'start_free_trial';
    }
  }
  return {
    platform: 'web',
    device: window.screen.width < 600 ? 'mobile' : 'desktop',
    product: 'appointments',
    route_name: routerService.currentRouteName,
    entry_type: 'pill',
    plan_token: planToken,
    intent,
    feature: featureId.toLowerCase()
  };
}